import Container from "@client/content/Containers/container";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";

import "./style.less";

export type AudioComponentProps = RootContainerProps & {
  audioFileUrl?: string;
  audioSoundCloudID?: string;
};

export default (props: AudioComponentProps) => (
  <Container className="wsc_content_audio" {...getContainerProps(props)}>
    <div className="audio-wrapper">
      {!!props.audioFileUrl && (
        <audio controls>
          <source src={props.audioFileUrl} type="audio/mp3" />
          <p>Your browser doesn't support HTML5 audio.</p>
        </audio>
      )}
      {!props.audioFileUrl && props.audioSoundCloudID && (
        <iframe
          src={`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${props.audioSoundCloudID}&amp;auto_play=false&amp;hide_related=false&amp;visual=true`}
        />
      )}
      {!props.audioFileUrl && !props.audioSoundCloudID && (
        <div className="no-audio">Please, add a reference to the audio file</div>
      )}
    </div>
  </Container>
);
